import TruthInLending from 'features/payOverTime/screens/application/TruthInLending/TruthInLending';

export default function Page() {
  return <TruthInLending />;
}
